import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer({ onOpenDisclaimer }) {
  return (
    <footer className="bg-slate-900 text-slate-200 py-16 mt-auto border-t border-slate-800" aria-label="Site Footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Col */}
          <div>
            <h2 className="text-white text-lg font-bold tracking-tight mb-4">Candor</h2>
            <p className="text-slate-300 text-sm leading-relaxed font-medium">
              Your AI-powered coding partner designed to work smarter, build faster, and deliver better data warehousing solutions.
            </p>
          </div>

          {/* Links Col */}
          <div>
            <h2 className="text-white text-md font-bold mb-4">Company</h2>
            <nav aria-label="Footer Company Links">
              <ul className="space-y-2.5 text-sm">
                <li>
                  <Link to="/about" className="text-slate-300 hover:text-blue-400 focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1 transition-colors">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/download" className="text-slate-300 hover:text-blue-400 focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1 transition-colors">
                    Download IDE
                  </Link>
                </li>
                <li>
                  <Link to="/newsletter" className="text-slate-300 hover:text-blue-400 focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1 transition-colors">
                    Newsletter
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-slate-300 hover:text-blue-400 focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1 transition-colors">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/press-release" className="text-slate-300 hover:text-blue-400 focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1 transition-colors">
                    Press Release
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Contact Col */}
          <div>
            <h2 className="text-white text-md font-bold mb-4">Contact</h2>
            <div className="space-y-3 text-sm text-slate-300 font-medium">
              <p className="font-bold text-white">Proden Technologies Incorporated</p>
              <p className="leading-relaxed">
                30 N Gould St<br />
                Sheridan, Wyoming 82801, USA
              </p>
              <p>
                Email:{' '}
                <a href="mailto:sales@candorsys.com" className="text-blue-400 hover:text-blue-300 font-semibold underline focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1">
                  sales@candorsys.com
                </a>
              </p>
              <p>
                Phone:{' '}
                <a href="tel:+17202355757" className="text-blue-400 hover:text-blue-300 font-semibold underline focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1">
                  +1 (720) 235-5757
                </a>
              </p>
            </div>
          </div>

          {/* Disclaimer Col */}
          <div>
            <h2 className="text-white text-md font-bold mb-4">Disclaimer</h2>
            <p className="text-slate-300 text-sm leading-relaxed mb-4 font-medium">
              AI features assist your workflow and may produce errors.{' '}
              <button
                onClick={onOpenDisclaimer}
                className="text-blue-400 hover:text-blue-300 font-bold underline underline-offset-4 focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1"
                aria-label="Read full AI Disclaimer"
              >
                Read full disclaimer
              </button>
              .
            </p>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-300 font-medium">
          <p>
            &copy; 2026 Candor. Operated by Proden Technologies Incorporated. All rights reserved.
          </p>
          <nav aria-label="Legal Policy Links" className="flex space-x-4">
            <Link to="/privacy-policy" className="hover:text-blue-400 hover:underline focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1">
              Privacy Policy
            </Link>
            <span aria-hidden="true">|</span>
            <Link to="/terms-and-policies" className="hover:text-blue-400 hover:underline focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1">
              Terms &amp; Conditions
            </Link>
            <span aria-hidden="true">|</span>
            <Link to="/refund-policy" className="hover:text-blue-400 hover:underline focus-visible:ring-2 focus-visible:ring-blue-400 rounded px-1">
              Refund Policy
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
